module.exports = __webpack_public_path__ + "static/media/Trading_Up_Desktop_Banner_STAKE@2x.3db7a556.jpg";